import React, { Component } from 'react';
import { Input } from 'antd';
import { calcGST } from 'store/utility';
import { connect } from 'react-redux';

class PriceInput extends Component {
  constructor(props) {
    super(props);

    const value = props.value || {};
    this.state = {
      price: value.price || 0,
      gst: this.props.settings ? this.props.settings.gst : 0,
      priceGST: value.price_gst || '$0.00',
    };
  }

  componentDidMount() {
    const { settings, value } = this.props;
    if (!settings || !value) {
      return;
    }

    let price = value.price ? value.price : 0;

    if (!price) {
      price = 0;
    }

    this.setState({
      gst: settings.gst || 0,
      price: price,
      priceGST: calcGST(price * 100, settings.gst || 0),
    });
  }

  componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      const { value } = nextProps;
      this.setState(prev => ({ ...prev, ...value }));
    }
  }

  priceChangeHandler = e => {
    const price = parseFloat(e.target.value || 0, 10);
    const priceGST = calcGST(price * 100, this.state.gst);
    if (!('value' in this.props)) {
      this.setState(prev => ({ ...prev, price, priceGST }));
    }
    this.triggerChange({ price, priceGST });
  };

  triggerChange = changedValue => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(Object.assign({}, this.state, changedValue));
    }
  };

  gstChangeHandler = e => {
    let gst = parseFloat(e.target.value || 0, 10);

    if (isNaN(gst)) {
      gst = 0;
    }

    if (gst > 100) {
      gst = 100;
    }

    if (gst < 0) {
      gst = 0;
    }

    const priceGST = calcGST(this.state.price * 100, gst);
    if (!('value' in this.props)) {
      this.setState(prev => ({ ...prev, gst, priceGST }));
    }

    this.triggerChange({ gst, priceGST });
  };

  render() {
    return (
      <div>
        <div>
          <Input
            defaultValue={'' + this.state.price}
            onChange={this.priceChangeHandler}
            style={{ width: '100px', marginRight: '3%' }}
            disabled={this.props.disabled}
          />
          <Input disabled={true} onChange={this.gstChangeHandler} value={this.state.gst} style={{ width: '50px' }} />
          <span> %</span>
        </div>
        <div>
          <span>Total: w/ GST: {this.state.priceGST}</span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    settings: state.setting.settings,
  };
};

export default connect(mapStateToProps)(PriceInput);



// WEBPACK FOOTER //
// ./src/components/QRcode/Input/PriceInput.js